'use client';

import { useParams } from 'next/navigation';
import { useLayoutEffect, useState } from 'react';

import { _t, Dict, Lang } from '@/lib/i18n';
import ar from '@/public/translations/ar.json';
import en from '@/public/translations/en.json';
import es from '@/public/translations/es.json';
import fr from '@/public/translations/fr.json';
import hi from '@/public/translations/hi.json';
import pt from '@/public/translations/pt.json';
import ru from '@/public/translations/ru.json';
import zh from '@/public/translations/zh.json';

class TranslationsService {
  languages: { [key: string]: Dict } = {
    en,
    es,
    zh,
    ru,
    hi,
    ar,
    fr,
    pt,
  };

  get(language: Lang): Dict {
    return this.languages[language] || this.languages['en'];
  }
}

const dictionaries = new TranslationsService();

export const useTranslation = () => {
  const params = useParams();
  const [translations, setTranslations] = useState<Dict>(dictionaries.get(params.lang as string));

  useLayoutEffect(() => {
    if (params.lang) {
      setTranslations(dictionaries.get(params.lang as string));
    }
  }, [params.lang]);

  const t = (key: string, options?: { [key: string]: number | string }) => {
    if (!translations) {
      return key;
    }
    return _t(key, translations, options);
  };

  return { t, isLoading: !translations };
};
